import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RideReminderResponse, RideRequestDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class RideReminderService extends UzurvRestService {
  readonly resourceUrl = 'rideReminders/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   *
   * @param rideReminderId
   * @param token
   */
  listRideReminderRides(rideReminderId: number, token: string): Observable<Array<RideRequestDetail>> {
    return this.get<Array<RideRequestDetail>>(`${this.resourceUrl}${rideReminderId}/rideRequests/`, {
      token
    }).pipe(map(response => Deserialize(response, RideRequestDetail)));
  }

  /**
   *
   * @param rideReminderId
   * @param token
   */
  listRideReminderResponses(rideReminderId: number, token: string): Observable<Array<RideReminderResponse>> {
    return this.get<Array<RideReminderResponse>>(`${this.resourceUrl}${rideReminderId}/responses/`, {
      token
    }).pipe(map(response => Deserialize(response, RideReminderResponse)));
  }

  /**
   *
   * @param rideReminderId
   * @param token
   * @param rideReminderResponse
   */
  confirmOrCancelRideReminderRide(
    rideReminderId: number,
    token: string,
    rideReminderResponse: RideReminderResponse
  ): Observable<RideReminderResponse> {
    return this.post<RideReminderResponse>(`${this.resourceUrl}${rideReminderId}/responses/?token=${token}`, rideReminderResponse).pipe(
      map(response => Deserialize(response, RideReminderResponse))
    );
  }
}
